import {
  POST_ORG_USER,
  POST_ORG_USER_SUCCESSFUL,
  POST_ORG_USER_FAILED,
  PUT_ORG_USER,
  PUT_ORG_USER_SUCCESSFUL,
  PUT_ORG_USER_FAILED,
  DELETE_ORGANIZATION_USER,
  DELETE_ORGANIZATION_USER_SUCCESSFUL,
  DELETE_ORGANIZATION_USER_FAILED,
  CLEAR_ALL_ORG_USER_MESSAGES,
  CLEAR_ALL_ORG_USER_MESSAGES_SUCCESSFUL,
} from "./actionTypes";

export const postOrgUser = (orgUser) => ({
  type: POST_ORG_USER,
  payload: { orgUser } 
});

export const postOrgUserSuccessful = (postOrgUserSuccessfulMessage) => ({
  type: POST_ORG_USER_SUCCESSFUL,
  payload: { postOrgUserSuccessfulMessage } 
});

export const postOrgUserFailed = (postOrgUserError) => ({
  type: POST_ORG_USER_FAILED,
  payload: { postOrgUserError } 
});

export const putOrgUser = (orgUser) => ({
  type: PUT_ORG_USER,
  payload: { orgUser } 
});

export const putOrgUserSuccessful = (putOrgUserSuccessfulMessage) => ({
  type: PUT_ORG_USER_SUCCESSFUL,
  payload: { putOrgUserSuccessfulMessage } 
});

export const putOrgUserFailed = (putOrgUserError) => ({
  type: PUT_ORG_USER_FAILED,
  payload: { putOrgUserError } 
});

export const deleteOrganizationUser = (orgUser) => ({
  type: DELETE_ORGANIZATION_USER,
  payload: { orgUser } 
});

export const deleteOrganizationUserSuccessful = (deleteOrgUserSuccessfulMessage) => ({
  type: DELETE_ORGANIZATION_USER_SUCCESSFUL,
  payload: { deleteOrgUserSuccessfulMessage } 
});

export const deleteOrganizationUserFailed = (deleteOrgUserError) => ({
  type: DELETE_ORGANIZATION_USER_FAILED,
  payload: { deleteOrgUserError } 
});

export const clearAllOrgUserMessages = () => ({
  type: CLEAR_ALL_ORG_USER_MESSAGES,
  payload: {}
});

export const clearAllOrgUserMessagesSuccessful = () => ({
  type: CLEAR_ALL_ORG_USER_MESSAGES_SUCCESSFUL,
  payload: {}
});
